import React, { useMemo } from 'react';
import BaseQuestionResponse from './BaseQuestionResponse';
import { getAnswerDomain } from 'js/utils/scoring';
import { scaleColorTraffic, standardColor } from 'js/utils/color';
import { scaleLinear } from '@visx/scale';

function LikertResponse({ question, response }) {
  const answer = response
    ? question.answers.find((a) => a.id === response.answer_id)
    : null;

  const answerDomain = getAnswerDomain(question.answers, 'value', 3);
  const [min, , max] = answerDomain;
  const fillColor = scaleColorTraffic.copy().domain(answerDomain);

  const scalePercentage = useMemo(
    () => scaleLinear({ domain: [min, max], range: [1, 100] }),
    [min, max]
  );

  const fillPercentage = response ? scalePercentage(+response.value) : 100;

  return (
    <BaseQuestionResponse question={question}>
      {answer == null ? (
        <span className="text-no-response">No response</span>
      ) : (
        <div className="question-review-response-bar">
          <div
            className="question-review-response-bar-fill"
            style={{
              width: `${fillPercentage}%`,
            }}
          >
            <div
              className="question-review-response-bar-fill-color"
              style={{
                backgroundColor: response
                  ? fillColor(response?.value)
                  : standardColor,
              }}
            />
          </div>
          <div className="question-review-response-bar-label-wrapper">
            <span className="question-review-response-bar-label">
              {answer?.text ?? answer?.value}
            </span>
          </div>
        </div>
      )}
    </BaseQuestionResponse>
  );
}

export default LikertResponse;
